import { render, staticRenderFns } from "./Letreiro.vue?vue&type=template&id=512e4bd8&scoped=true"
import script from "./Letreiro.vue?vue&type=script&lang=js"
export * from "./Letreiro.vue?vue&type=script&lang=js"
import style0 from "./Letreiro.vue?vue&type=style&index=0&id=512e4bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512e4bd8",
  null
  
)

export default component.exports